import { Divider, Grid, Stack } from '@mui/material'
import { Box } from '@mui/system'
import MUIDataTable from 'mui-datatables'
import React, { useState } from 'react'
import { ContainedButton } from '../../components/600/MyButtons'
import { useEffect } from 'react'
import { MyDropdown } from '../../components/600/MyDropdown'
//import api from '../api/mainAPI' //axios req cors and proxy enabled ig
//import BatchReportContext from './contexts/ContextProvider'
import { MyTab } from '../../components/600/MyTabs'
import { MyBarChartCard2,MyPieChartCard2, MyPieChartCard, MyTextCard } from '../../components/600/MyCards'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
// import { LoadCoverage } from './loadCoverage'


const options = {
  filterType: 'checkbox',
};

const CourseReport = () => {
  const currentYear = (new Date()).getFullYear();
  const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
  const [data,setData]=useState()
  const [semester,setSemester]=useState("I")
  const [year,setYear]=useState(currentYear)
  const api=useAxiosPrivate()
  const [visualize, setVisualize] = useState(false);
    useEffect(()=>{
        let isMounted=true;
        const controller=new AbortController();
        const getData=async ()=>{
          try{
            const report=await api.get(`request/report?year=${year}&semester=${semester}`,{
              signal:controller.signal
            })
            // console.log(profile.data)
            isMounted &&  setData(report.data)
          }
          catch(err){
            console.error(err)
          }
        }
        getData();
        return ()=>{
          isMounted=false;
          controller.abort()
        }
          },[semester,year])
  function handleVisualization() {
    setVisualize(!visualize)
  }
// console.log(data)
  return (
    <Box 
    sx={{m: 2}}
    >
      {/* Filters */}
      <Stack 
          direction={{xs: 'column', sm: 'row'}}
          alignItems={{xs:'right', sm: 'center'}}
          justifyContent='flex-end'
          spacing={2}
          divider={<Divider orientation='vertical' flexItem/>}
          sx={{
            m: 1, 
            md: {
              backgroundColor: '#ff0',
            }
          }}
      >
          {/* Semester filter */}
          <MyDropdown inputs={{
            name: 'Semester Term', 
            defaultValue:semester ,
            handleChange:(e)=> setSemester(e.target.value),
            id: 'Semester_filter', 
            values: ["I", "II","Summer"],
          }} />

          {/* Term Filter */}
          <MyDropdown inputs={{
            name: 'Academic Year', 
            defaultValue: year,
            handleChange:(e)=> setYear(e.target.value),
            id: 'Term_filter', 
            values: range(currentYear, currentYear - 30, -1)
          }} />

          {/* Charts Toggle Button */}
          <ContainedButton 
            variant='contained' 
            color='secondary'
            onClick={handleVisualization}  
          >
            {visualize ? "Visualize" : "Report"}
          </ContainedButton>
      </Stack>
      {/* Visualize */}
      <Grid container 
          spacing={{ xs: 2, md: 3 }} 
          columns={{ xs: 4, sm: 8, md: 12 }} 
          sx={{m: 1, mb: 2}}
      >
          <MyTextCard inputs={{
            value: data?.overload+data?.extension+data?.part || 0,
            title: 'Total Requests',
            size: 3,
          }}/>
          <MyTextCard inputs={{
            value: data?.unsigned || 0,
            title: 'Pending Request',
            size: 3,
          }}/>
          {visualize && 
          <MyBarChartCard2 inputs={{
            title: "Agreement Status",
            option1: 'Unsigned',
            value1: data?.unsigned || 0,
            option2: 'Signed',
            value2: data?.signed || 0,            
            option3: 'Rejected',
            value3: data?.rejected || 0,
          }}/>}
          {visualize && 
          <MyBarChartCard2 inputs={{
            title: "Agreement Type",
            option1: 'Overload',
            value1: data?.overload || 0,
            option2: 'Extension',
            value2: data?.extension || 0,            
            option3: 'Part-Time',
            value3: data?.part || 0,
          }}/>}
          {!visualize && 
          <MyPieChartCard2 inputs={{
              mydata: {
                name: "Agreement Status",
                option1: "Unsigned",
                option2: "Signed",
                option3: "Rejected",
                value1:data?.unsigned || 0,
                value2:data?.signed || 0, 
                value3: data?.rejected || 0,
              },
            }}
          />}
          {!visualize && 
          <MyPieChartCard2 inputs={{
            mydata: {
                name: "Agreement TYpe",
                option1: "Overload",
                option2: "Extension",
                option3: "Part-Time",
                value1:data?.overload || 0,
                value2:data?.extension || 0, 
                value3: data?.part || 0,
            },
          }}/>
          }
      </Grid>
      {/* Load Coverage */}
      {/* <LoadCoverage  inputs={{
        load: reportState.load
      }}/> */}
      {/* Tabs */}

    </Box>
  )
}

export default CourseReport